const cartReducer = (state = { items: [], isCartOpen: false, numberStaffCart: 0, selectedCart: 1 }, action) => {
    switch (action.type) {
        case "GET_CART_ITEMS":
            return state;
        case "SET_CART_ITEMS":
            return { ...state, items: action.items };
        case "CLEAR_CART_ITEMS":
            return { ...state, items: [] };
        case "ADD_NEW_TO_CART":
            const itemExists = (state.items || []).find(item => item.productId === action.item.product_id) || [];
            if (itemExists.length > 0) {
                // If the item exists, increment its quantity by 1
                return {
                    ...state,
                    items: state.items.map((item) =>
                        item.productId === action.item.product_id
                            ? { ...item, quantity: item.quantity + 1 }
                            : item
                    )
                };
            } else {
                const newItem = {
                    productId: action.item.product_id,
                    quantity: 1,
                    product_category: action.item.product_category,
                    product_name: action.item.product_name,
                    product_price: action.item.product_price,
                    imageURL: action.item.imageURL
                    // You can add other item properties here if needed
                };

                return {
                    ...state,
                    items: state.items ? [...state.items, newItem] : [newItem]
                };
            }
        case "OPEN_CART":
            return { ...state, isCartOpen: true };
        case "SET_NUMBER_OF_STAFF_CART":
            return { ...state, numberStaffCart: action.numberStaffCart }
        case "SET_SELECT_CART":
            return { ...state, selectedCart: action.selectedCart }
        case "CLOSE_CART":
            return { ...state, isCartOpen: false };
        case "INCREMENT_CART_ITEM_QUANTITY":
            return {
                ...state,
                items: state.items.map((item) =>
                    item.productId === action.productId
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                ),
            };

        case "DECREMENT_CART_ITEM_QUANTITY":
            return {
                ...state,
                items: state.items.map((item) =>
                    item.productId === action.productId
                        ? { ...item, quantity: item.quantity - 1 }
                        : item
                ),
            };

        default:
            return state;
    }
};

export default cartReducer;
